import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { FcNext, FcPrevious } from "react-icons/fc";
import { useDispatch, useSelector } from "react-redux";
import { campaignAction } from "../../store/campaign-store";

const ImageSearch = (props) => {
  const { toggleRightshow } = props;
  const inputRef = useRef();
  const [showImageSearchResult, setShowImageSearchResult] = useState(false);
  const [searchImageResults, setSearchImageResults] = useState({});
  const [searchImagePexelsResults, setSearchImagePexelsResults] = useState({});
  const [available, setAvailable] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [pageNumber, setpageNumber] = useState(1);

  const dispatch = useDispatch();

  const single_layer = useSelector((state) => state.campaign.single_layer);

  const editSlideData = useSelector((state) => state.campaign.editSlideData);

  useEffect(() => {
    async function searchImages() {
      try {
        const apiUrl = `https://pixabay.com/api/?key=${process.env.REACT_APP_PIXABAY}&q=${keyword}&image_type=all&safesearch=true&per_page=20&page=${pageNumber}`;
        const response = await axios.get(apiUrl);
          // console.log(response.data);
          const res = await response.data.hits;

          if (res.length !== 0) {
            
            if(res.length < 15){
              
              const pexelsUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=15&page=${pageNumber}`;
              const pexelsResponse = await axios(pexelsUrl, {
                headers: {
                  Authorization:process.env.REACT_APP_PEXELS
                }
              });
              const resPexels = await pexelsResponse.data.photos;
              setSearchImagePexelsResults(resPexels)
            }
            setShowImageSearchResult(true);
            setSearchImageResults(res); 
            setAvailable(2);
          } else {
            
            const pexelsUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=15&page=${pageNumber}`;
            const pexelsResponse = await axios(pexelsUrl, {
              headers: {
                Authorization:process.env.REACT_APP_PEXELS
              }
            });
            const resPexels = await pexelsResponse.data.photos;

            if (resPexels.length !== 0) {
              setShowImageSearchResult(true);
              setSearchImagePexelsResults(resPexels)
              setAvailable(2);
            }else{
              setSearchImageResults([]);
              setSearchImagePexelsResults([])
              setAvailable(1);
            }
          }
      } catch (error) {
        console.error(error);
      }
    }

    if (keyword) {
      searchImages();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber]);

  const handleClick = async (event, type) => {
    event.preventDefault();
    console.log(event.target.innerText)
    if (type === "search") {
      if (keyword.length > 0) {
        try {
          const apiUrl = `https://pixabay.com/api/?key=${process.env.REACT_APP_PIXABAY}&q=${keyword}&image_type=all&safesearch=true&per_page=20&page=${pageNumber}`;
          const response = await axios.get(apiUrl);
          // console.log(response.data);
          const res = await response.data.hits;

          if (res.length !== 0) {
            
            if(res.length < 15){
              
              const pexelsUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=15&page=${pageNumber}`;
              const pexelsResponse = await axios(pexelsUrl, {
                headers: {
                  Authorization:process.env.REACT_APP_PEXELS
                }
              });
              const resPexels = await pexelsResponse.data.photos;
              setSearchImagePexelsResults(resPexels)
            }
            setShowImageSearchResult(true);
            setSearchImageResults(res); 
            setAvailable(2);
          } else {
            const pexelsUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=15&page=${pageNumber}`;
            const pexelsResponse = await axios(pexelsUrl, {
              headers: {
                Authorization:process.env.REACT_APP_PEXELS
              }
            });
            const resPexels = await pexelsResponse.data.photos;

            if (resPexels.length !== 0) {
              setShowImageSearchResult(true);
              setSearchImagePexelsResults(resPexels)
              setAvailable(2);
            }else{
              setSearchImageResults([]);
              setSearchImagePexelsResults([])
              setAvailable(1);
            }
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        inputRef.current.focus();
      }
    }
  };

  const updateNewData = async (e, url) => {
    e.preventDefault();

    if (single_layer.name.indexOf("bg_image") === 0) {
      dispatch(campaignAction.setImageEditor({ content: url }));
    } else {
      let new_layer_data = { ...single_layer };
      new_layer_data.src = url;

      await dispatch(
        campaignAction.setSingleLayerData({ data: new_layer_data })
      );

      await dispatch(
        campaignAction.setSingleSlideData({ layer_name: single_layer.name })
      );

      dispatch(campaignAction.appendVideoData());

      var newData = { ...editSlideData };

      newData.logo = url;
      dispatch(campaignAction.setSlideData({ data: newData }));

      dispatch(campaignAction.setImageLoadedS3({ is_loaded_img: false }));
    }
    toggleRightshow();
  };

  return (
    <>
      <div className="row">
        <div className="d-flex align-items-center justify-content-center">
          <div className="input-group p-4 mb-3">
            <input
              type="text"
              className="form-control shadow-none"
              placeholder="Enter Keyword"
              aria-label="Recipient's username"
              aria-describedby="button-addon2"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              ref={inputRef}
            />
            <button
              className="btn btn-outline-secondary shadow-none p-2"
              type="button"
              id="button-addon2"
              onClick={(event) => handleClick(event, "search")}
            >
              Search
            </button>
          </div>
        </div>
        <div className="row">
          {showImageSearchResult && (
            <div className="container">
              <div className="media_gallery" style={{ height: "200px" }}>
                {available === 2 && (
                  <ul>
                    {searchImageResults.length > 0 &&
                      searchImageResults.map(
                        ({ id, webformatURL, fullHDURL }) => (
                          <li key={id}>
                            <img
                              src={webformatURL}
                              className="img_full"
                              alt="img"
                            />
                            <button
                              onClick={(e) => updateNewData(e, fullHDURL)}
                              className="hvr"
                            >
                              <span className="btn">Select</span>
                            </button>
                          </li>
                        )
                      )
                    }
                    {searchImagePexelsResults.length > 0 &&
                      searchImagePexelsResults.map(
                        ({ id, src }) => (
                          <li key={id}>
                            <img
                              src={src.tiny}
                              className="img_full"
                              alt="img"
                            />
                            <button
                              onClick={(e) => updateNewData(e, src.original)}
                              className="hvr"
                            >
                              <span className="btn">Select</span>
                            </button>
                          </li>
                        )
                      )
                    }
                  </ul>
                )}

                {available === 1 && <p>No data found!</p>}
              </div>
              <div
                className="btn-group btn-group-toggle mt-2"
                data-toggle="buttons"
                style={{ float: "right" }}
              >
                <label className="btn bg-transparent px-0">
                  <button
                    className="bg-secondary border-0 text-white"
                    disabled={pageNumber <= 1}
                    onClick={() => setpageNumber(pageNumber - 1)}
                  >
                    <FcPrevious /> Prev
                  </button>
                </label>

                <label
                  className={`btn bg-transparent px-0 ${
                    pageNumber >= 1 && "active"
                  }`}
                >
                  <button
                    className="bg-secondary border-0 text-white"
                    onClick={() => setpageNumber(pageNumber + 1)}
                  >
                    Next <FcNext />
                  </button>
                </label>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ImageSearch;
